import { render, staticRenderFns } from "./copyable.vue?vue&type=template&id=81f2110e&scoped=true&"
import script from "./copyable.vue?vue&type=script&lang=js&"
export * from "./copyable.vue?vue&type=script&lang=js&"
import style0 from "./copyable.vue?vue&type=style&index=0&id=81f2110e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f2110e",
  null
  
)

export default component.exports